export const isMobile = () => {
    if (window.screen.width < 767) {
      // 768px portrait
      return true;
    } else {
      return false;
    }
  };
  export const isTab = () => {
    if (window.screen.width >= 768 && window.screen.width < 992) {
      // 768px portrait
      return true;
    } else {
      return false;
    }
  };
  
  // smaller mobile devices
  export const isMobLessThan400 = () => {
    if (window.screen.width >= 300 && window.screen.width <= 400) {
      // width 300px to 400px
      return true;
    } else {
      return false;
    }
  };